// prettier-disable-next-line
import { addIdToData } from "@/utils/helpers.js";
const stops = [
  {
    text: {
      title: {
        en: `Welcome to Gabrielle Chanel. Fashion Manifesto.`
      },
      stopNumber: {
        en: "01"
      }
    },
    image: require("../assets/images/stop-images/stop-1.jpg"),
    audio: require("../assets/audio/english/stop-1.mp3"),
    audioDuration: "05:14"
  },
  {
    text: {
      title: {
        en: `Modern clothes for modern women.`
      },
      stopNumber: {
        en: "02"
      }
    },
    image: require("../assets/images/stop-images/stop-2.jpg"),
    audio: require("../assets/audio/english/stop-2.mp3"),
    audioDuration: "03:03"
  },
  {
    text: {
      title: {
        en: `Transposing masculine dress codes to the feminine.`
      },
      stopNumber: {
        en: "03"
      }
    },
    image: require("../assets/images/stop-images/stop-3.jpg"),
    audio: require("../assets/audio/english/stop-3.mp3"),
    audioDuration: "04:53"
  },
  {
    text: {
      title: {
        en: `Marilyn Monroe’s pyjamas – CHANEL N°5.`
      },
      stopNumber: {
        en: "04"
      }
    },
    image: require("../assets/images/stop-images/stop-4.jpg"),
    audio: require("../assets/audio/english/stop-4.mp3"),
    audioDuration: "03:57"
  },
  {
    text: {
      title: {
        en: `The LBD (Little Black Dress) – Chanel’s ‘Ford’.`
      },
      stopNumber: {
        en: "05"
      }
    },
    image: require("../assets/images/stop-images/stop-5.jpg"),
    audio: require("../assets/audio/english/stop-5.mp3"),
    audioDuration: "02:53"
  },
  {
    text: {
      title: {
        en: `Chanel and the stage and screen – ‘Qui qu’a vu Coco?’`
      },
      stopNumber: {
        en: "06"
      }
    },
    image: require("../assets/images/stop-images/stop-6.jpg"),
    audio: require("../assets/audio/english/stop-6.mp3"),
    audioDuration: "03:51"
  },
  {
    text: {
      title: {
        en: `The early life of ‘Gabrielle Chasnel’.`
      },
      stopNumber: {
        en: "07"
      }
    },
    image: require("../assets/images/stop-images/stop-7.jpg"),
    audio: require("../assets/audio/english/stop-7.mp3"),
    audioDuration: "04:20"
  },
  {
    text: {
      title: {
        en: `The Russians and the scent of polished leather.`
      },
      stopNumber: {
        en: "08"
      }
    },
    image: require("../assets/images/stop-images/stop-8.jpg"),
    audio: require("../assets/audio/english/stop-8.mp3"),
    audioDuration: "02:26"
  },
  {
    text: {
      title: {
        en: `“Fit to rule a man or an Empire.”`
      },
      stopNumber: {
        en: "09"
      }
    },
    image: require("../assets/images/stop-images/stop-9.jpg"),
    audio: require("../assets/audio/english/stop-9.mp3"),
    audioDuration: "03:16"
  },
  {
    text: {
      title: {
        en: `Modern classics: the 2.55 bag and the two-toned shoe.`
      },
      stopNumber: {
        en: "10"
      }
    },
    image: require("../assets/images/stop-images/stop-10.jpg"),
    audio: require("../assets/audio/english/stop-10.mp3"),
    audioDuration: "02:38"
  },
  {
    text: {
      title: {
        en: `The Comeback.`
      },
      stopNumber: {
        en: "11"
      }
    },
    image: require("../assets/images/stop-images/stop-11.jpg"),
    audio: require("../assets/audio/english/stop-11.mp3"),
    audioDuration: "04:23"
  },
  {
    text: {
      title: {
        en: `The Embodiment of Freedom – The Suit.`
      },
      stopNumber: {
        en: "12"
      }
    },
    image: require("../assets/images/stop-images/stop-12.jpg"),
    audio: require("../assets/audio/english/stop-12.mp3"),
    audioDuration: "04:01"
  },
  {
    text: {
      title: {
        en: `America`
      },
      stopNumber: {
        en: "13"
      }
    },
    image: require("../assets/images/stop-images/stop-13.jpg"),
    audio: require("../assets/audio/english/stop-13.mp3"),
    audioDuration: "02:40"
  },
  {
    text: {
      title: {
        en: `Chanel and jewellery: “an ornament and an amusement”`
      },
      stopNumber: {
        en: "14"
      }
    },
    image: require("../assets/images/stop-images/stop-14.jpg"),
    audio: require("../assets/audio/english/stop-14.mp3"),
    audioDuration: "04:18"
  },
  {
    text: {
      title: {
        en: `A Story of Liberty`
      },
      stopNumber: {
        en: "15"
      }
    },
    image: require("../assets/images/stop-images/stop-15.jpg"),
    audio: require("../assets/audio/english/stop-15.mp3"),
    audioDuration: "02:54",
    letterbox: true
  },
  {
    text: {
      title: {
        en: `The power of Chanel’s image: ‘If I don’t wear it, I don’t make it.’`
      },
      stopNumber: {
        en: "16"
      }
    },
    image: require("../assets/images/stop-images/stop-16.jpg"),
    audio: require("../assets/audio/english/stop-16.mp3"),
    audioDuration: "02:50",
    letterbox: true
  },
  {
    text: {
      title: {
        en: `Chanel’s Legacy`
      },
      stopNumber: {
        en: "17"
      }
    },
    image: require("../assets/images/stop-images/stop-17.jpg"),
    audio: require("../assets/audio/english/stop-17.mp3"),
    audioDuration: "04:27"
  }
];

export default addIdToData(stops);
